import type { ReactNode } from "react";
import { Icon, type IconName } from "../Icon";

// Status is never color alone (UX-DESIGN.md §4.6/§6): every tone carries
// an icon and the text label itself.

export type Tone = "neutral" | "info" | "success" | "warning" | "error";

const TONE_ICON: Record<Tone, IconName> = {
  neutral: "circle",
  info: "info",
  success: "checkCircle",
  warning: "alert",
  error: "error",
};

export function StatusPill({ tone, children, icon }: { tone: Tone; children: ReactNode; icon?: IconName }) {
  return (
    <span className={`pill pill-${tone}`}>
      <Icon name={icon ?? TONE_ICON[tone]} />
      {children}
    </span>
  );
}

/** Plain badge without the status icon, for counts and tags. */
export function Badge({ children, tone = "neutral" }: { children: ReactNode; tone?: Tone }) {
  return <span className={`pill pill-${tone}`}>{children}</span>;
}
